import { render, staticRenderFns } from "./CommercialClientList.vue?vue&type=template&id=8f7a9ca6&scoped=true"
import script from "./CommercialClientList.vue?vue&type=script&lang=js"
export * from "./CommercialClientList.vue?vue&type=script&lang=js"
import style0 from "./CommercialClientList.vue?vue&type=style&index=0&id=8f7a9ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7a9ca6",
  null
  
)

export default component.exports